import { TActions } from '../../../AppModulesWrapper';

import { IRecommendedPackagesState } from '../../types/reducers/recommendedPackages';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import {
  SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE,
  SET_SELECTED_RECOMMENDED_PACKAGE_ID,
} from '../../actions/recommendedPackages';

import { defaultState } from './defaultState';
import { RESET_STATE } from '../../actions/resetState';

export const recommendedPackages = (
  state: IRecommendedPackagesState = defaultState,
  action: TActions,
): IRecommendedPackagesState => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS:
      return { ...state, packages: action.payload.recommendedPackages };

    case SET_SELECTED_RECOMMENDED_PACKAGE_ID:
      return { ...state, selectedPackageId: action.payload };

    case SET_RECOMMENDED_PACKAGE_CHECKOUT_FILL_BALANCE:
      return { ...state, isFillBalance: action.payload };

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
